import React from "react";
import Countdown from "react-countdown";
import ExpiredNotice from "../ExpiredNotice";
import ShowCounter from "../ShowCounter";
import { RendererProps, TimerProps } from "./types";

const CountdownTimer: React.FC<TimerProps> = () => {
  const renderer = ({ hours, minutes, seconds, completed }: RendererProps) => {
    if (completed) {
      // Render a completed state
      return <ExpiredNotice />;
    } else {
      // Render a countdown
      return (
        <ShowCounter
          days={7}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
        />
      );
    }
  };

  return <Countdown date={Date.now() + 60000} renderer={renderer} />;
};

export default CountdownTimer;
